module.exports = __webpack_public_path__ + "static/img/dl_telegram.165a8d27.png";